import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    now: null,
    timeInterval: null,
    OGR: 0, //on going requests
    isGetting: {}, // true if is getting something (account for example)
    snackbar: {
      show: false,
      text: '',
      color: ''
    },
  },
  mutations: {
    setTime(state, time) {
      state.now = time;
      if (state.timeInterval) window.clearInterval(state.timeInterval)
      state.timeInterval = window.setInterval(() => state.now.add(1, 'second'), 1000)
    },
    updateIsGetting(state, data) {
      state.isGetting = {
        ...state.isGetting,
        ...data
      };
    },
    incrementOGR(state) {
      state.OGR++;
    },
    decrementOGR(state) {
      state.OGR--;
    },
    setSnackbar(state, snackbar) {
      state.snackbar = snackbar;
    },
    setUser(state, user) {
      state.user = user;
    },
  }
})